import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Navigation24Regular } from '@fluentui/react-icons'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { RestSchemas } from '@/contexts/QueryProvider'
import { AddOrganisationForm } from '@/ui/Forms/AddOrganisationForm'
import { AddUserToOrgForm } from '@/ui/Forms/AddUserToOrgForm'
import { AddWorkspaceForm } from '@/ui/Forms/AddWorkspaceForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { useSessionStorage } from '@/hooks'
import { isSuperUser } from '@/util'

type MessagesSubscriptionsOrganisationSummary = RestSchemas['Messages.Subscriptions.OrganisationSummary']

export function RowActionsMenu({ org }: { org: MessagesSubscriptionsOrganisationSummary }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'editOrg' | 'addUserToOrg' | 'addWorkspace'>('none')

  const [userRole] = useSessionStorage('roles', 1)
  const canEditOrg = isSuperUser(userRole)

  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} />
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            <MenuItem
              onClick={() => {
                searchParams.set('tab', 'details')
                searchParams.set('orgId', org.id.toString())
                setSearchParams(searchParams)
              }}
            >
              View organisation
            </MenuItem>
            <MenuItem
              disabled={!canEditOrg}
              onClick={() => {
                setDrawerOpen('editOrg')
              }}
            >
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                setDrawerOpen('addUserToOrg')
              }}
            >
              Add user
            </MenuItem>
            <MenuItem
              onClick={() => {
                setDrawerOpen('addWorkspace')
              }}
            >
              Add workspace
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>

      <OverlayDrawerComponent
        open={drawerOpen === 'editOrg'}
        setOpen={(open) => setDrawerOpen(open ? 'editOrg' : 'none')}
        title="Edit organisation"
        content={
          <AddOrganisationForm
            // edit
            onSubmit={() => {
              setDrawerOpen('none')
            }}
            selectedOrg={org}
          />
        }
      />
      <OverlayDrawerComponent
        open={drawerOpen === 'addUserToOrg'}
        setOpen={(open) => setDrawerOpen(open ? 'addUserToOrg' : 'none')}
        title={`Add user to ${org.name ?? 'organisation'}`}
        content={<AddUserToOrgForm organisationId={org.id} onSubmit={() => setDrawerOpen('none')} />}
      />
      <OverlayDrawerComponent
        open={drawerOpen === 'addWorkspace'}
        setOpen={(open) => setDrawerOpen(open ? 'addWorkspace' : 'none')}
        title="Add a workspace"
        size="medium"
        content={<AddWorkspaceForm onSubmit={() => setDrawerOpen('none')} orgId={org.id} />}
      />
    </>
  )
}
